export default {
    useCasesTitle1: "某知名海外金融平台案例",
   
    useCasesContent1: "客户在海外信贷领域深耕多年，积累了大量的自有数据，在此基础上自主建立了风控模型。为继续优化模型，希望引入外部数据和产品，深入了解后，选择与seeder合作。",

    useCasesContent2: "客户与seeder在反欺诈产品及风险评估产品有着密切合作，借助人脸识别、人脸比对等技术手段，识别人证不一的欺诈风险；结合客户自有数据及外部数据输出客户画像，评估客户风险，提高对客户风险判断的准确度。",

    useCasesContent3: "应用seeder产品后，降低了整体欺诈风险，提高了对高风险客户的识别率，首期逾期率及坏账率明显下降。",
};